import axios from "../../../../utils/axios-private";

export const getDistrics = () => {
  return {
    type: "GET_DROPDOWN_DISTRICTS",
    payload: new Promise((resolve, reject) => {
      const controller = new AbortController();
      const url = `/databasic/kecamatan`;
      axios
        .get(url, { signal: controller.signal })
        .then((response) => {
          resolve({ response });
        })
        .catch((error) => {
          controller.abort();
          reject(error);
        });
    }),
  };
};
